import { SeparationType } from '../../../enums/SeparationType';

export class GenerateGroupedGeneralOrdersReportInput {
  userId?: number;
  initialDate: string | null;
  finalDate: string | null;
  onlyOpenOrders: boolean;
  onlyCancelledOrders: boolean;
  orderIds?: number[];
  includeHeaders: boolean = true;
  returnStringData: boolean = false;
  locationId: number | null;
  separationType?: SeparationType | null;
  locationIds: number[];
  includesCrossChannelSale: boolean;
}